import React, { useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { useAsyncSetState } from "use-async-setstate";
import { useMutation } from "@apollo/client";
import Modal from "../bootstrap/modal";
import { 
  acceptTNCMutation, 
  logoutMutation,
  getAcceptTNCMutationResult, 
} from "../logic/user";
import Formsy from "formsy-react";
import TextField from "../bootstrap/input";
import { sleep } from "../../utils";
import "../../style/custom/tnc-with-password.scss";
import StandardTerms from "../standard-terms";
import PrivacyPolicy from "../portal/privacy-policy";


function TermsAndCondition({checked, setCheck}) {
  const [showTerm, setTerm] = useState(false);
  const [showPolicy, setPolicy] = useState(false);

  return (
    <>
      {showTerm && <StandardTerms onClose={() => setTerm(false)} />}
      {showPolicy && <PrivacyPolicy onClose={() => setPolicy(false)} />}
      <div className="tnc-modal-agreement">
        <div className="vw-checkbox" onClick={async () => setCheck(!checked)}>
          <i
            onClick={async () => setCheck(!checked)}
            style={{ fontSize: 18 }}
            className={`mr-2 ${
              checked ? "far fa-check-square" : "far fa-square"
            }`}
          />
          {"I have read and agree to the "}
          <a onClick={() => setTerm(true)} className="mx-1">
            {"Terms of Service"}
          </a>
          {" and "}
          <a onClick={() => setPolicy(true)} className="mx-1">
            {"Privacy Policy"}
          </a>
          .
        </div>
      </div>
    </>
  );
}

export default function TNC({ user }) {
  const authUrl = process.env.AUTH_URL;
  const portalUrl = process.env.PORTAL_URL;
  const [state, setState] = useAsyncSetState({
    processing: false,
    error: "",
  });
  const { requireAcceptTNC, requireChangePassword } = user;
  const [checked, setCheck] = useAsyncSetState(false);
  const [show, setShow] = useAsyncSetState(true);
  const [acceptTNC] = useMutation(acceptTNCMutation);
  const [authDetails, setAuthDetails] = useAsyncSetState(false);
 
  const [logout] = useMutation(logoutMutation);
  const formRef = useRef(null);
  const loginRef = useRef(null);

  async function onHandleLogout() {
    await logout();
    localStorage.removeItem("authToken");
    return (window.location = "/");
  }
  async function onHandleSubmit(data) {
    setState(prev => ({...prev, processing: true}))
    let variables = {
      password: "",
      oldPassword: "",
    };
    let result;
    let acceptTNCResult;
    
    if (requireChangePassword) {
      await setState((prevState) => ({...prevState, processing: true}));
      const { password, newpassword, confirmpassword } = data;
      
      try {
        if (confirmpassword !== newpassword) {
          return setState((prevState) => ({
            ...prevState,
            error: "Passwords don't match",
            processing: false
          }));
        }

        if (password === newpassword) {
          return setState((prevState) => ({
            ...prevState,
            error: "New password cannot be same as old password",
            processing: false
          }));
        }

        variables.password = newpassword;
        variables.oldPassword = password;
        result = await acceptTNC({
          variables,
        });
        if (result?.errors?.length > 0) {
        
          return setState((prevState) => ({
            ...prevState,
            error: result.errors[0].message,
          }));
        }
        
        acceptTNCResult = await getAcceptTNCMutationResult(result);

      } catch (error) {
        console.log({error})
        return setState((prevState) => ({
          ...prevState,
          error: error?.message,
          processing: false
        }));
      }
    } else {
      result = await acceptTNC({
        variables,
      });
      if (result?.errors?.length > 0) {
      
        return setState((prevState) => ({
          ...prevState,
          error: result.errors[0].message,
        }));
      }
      
      acceptTNCResult = await getAcceptTNCMutationResult(result);

    }



    if (acceptTNCResult || requireChangePassword) {
      if (requireChangePassword) {
        await setAuthDetails({
          userName: user.email,
          password: data.newpassword,
        });
        await sleep(100);
        if (authUrl && authUrl !== "") {
          return loginRef.current.submit();
        }
      }
      setState(prev => ({...prev, processing: false}))
      return setShow(false);
    } else {
      return setState((prevState) => ({
        ...prevState,
        error: "Failed to accept the Terms and Conditions, please try again",
      }));
    }
  }

  function submitLabel() {
    let message = "";
    if (
      (requireChangePassword && requireAcceptTNC) ||
      (!requireChangePassword && requireAcceptTNC)
    ) {
      message = "I Accept";
    } else if (requireChangePassword && !requireAcceptTNC) {
      message = "Change";
    }
    return message;
  }
  function headerLabel() {
    let message = "";
    if (
      (requireChangePassword && requireAcceptTNC) ||
      (!requireChangePassword && requireAcceptTNC)
    ) {
      message = "Terms & Conditions";
    } else if (requireChangePassword && !requireAcceptTNC) {
      message = "Password reset is required";
    }
    return message;
  }

  return (
    <div>
      <form ref={loginRef} name="login" action={authUrl} method="post">
        <input type="hidden" value="hotspot" name="radius11" />
        <input type="hidden" name="dst" value={`${portalUrl}`} />
        <input
          type="hidden"
          name="username"
          value={(authDetails?.userName || "").toLowerCase()}
        />
        <input type="hidden" name="password" value={authDetails?.password} />
      </form>

      <Modal
        show={show}
        title={headerLabel()}
        className="tnc-agreement-modal"
        onClose={() => onHandleLogout()}
        bodyProps={{ style: { padding: 0 } }}
        footer={
          <div className="tnc-footer-actions">
            <Button
              type="button"
              variant="black-text"
              disabled={state.processing}
              onClick={onHandleLogout}
            >
              {"Logout"}
            </Button>
            <Button
              className="btn-darkblue"
              type="submit"
              disabled={state.processing || (requireAcceptTNC && !checked)}
              onClick={() =>
                requireChangePassword
                  ? formRef.current.submit()
                  : onHandleSubmit()
              }
            >
              {submitLabel()}
            </Button>
          </div>
        }
      >
        <div className="tnc-with-password-modal">
          {requireAcceptTNC && requireChangePassword && <></>}
          {requireChangePassword && (
            <>
              <ChangePassword
                form={requireChangePassword ? formRef : null}
                handleSubmit={onHandleSubmit}
                error={state.error}
              />
            </>
          )}
          {requireAcceptTNC && (
            <>
              <TermsAndCondition checked={checked} setCheck={setCheck} />
            </>
          )}
        </div>
      </Modal>
    </div>
  );
}

function ChangePassword(props) {
  const { handleSubmit, form } = props;
  return (
    <div className="tnc-change-password-section">
      <Formsy ref={form} onValidSubmit={async (data) => handleSubmit(data)}>
        <div className="change-intro">
          <p className="text-intro">
            {"For your security, we need you to reset the password on your account."}
          </p>
        </div>
        {props.error && (
          <div className="password-notification-error">
            <p className="notif-text">
              <i
                className="fas fa-exclamation-circle"
              />
              {props.error}
            </p>
          </div>
        )}
        <div className="change-pw-field-current">
          <TextField
            label={"Current Password"}
            name="password"
            placeholder={"Current Password"}
            type="password"
            disabled={props.processing}
            required
          />    
        </div>
        <div className="change-pw-field-new">
          <TextField
            label={"New Password"}
            name="newpassword"
            placeholder={"New Password"}
            type="password"
            disabled={props.processing}
            required
          />
        </div>
        <div className="change-pw-field-confirm">
          <TextField
            label={"Confirm Password"}
            name="confirmpassword"
            placeholder={"Confirm Password"}
            type="password"
            disabled={props.processing}
            required
          />
        </div>
      </Formsy>
    </div>
  );
}
